import Lookup from 'src/componentes/select2';
import LucideIcon from 'src/componentes/lucide-icon';

const GrauRiscoLookup = ({ ...rest }) => {
  const renderFarol = (item) => {
    return (
      item &&
      item.data && (
        <span>
          <LucideIcon
            icon="circle"
            size={18}
            color={item.data.cor}
            colorHover={item.data.cor}
          />
          <span className="ml-2">{item.data.descricao}</span>
        </span>
      )
    );
  };

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/GrauRiscoLookup"
      clearable={false}
      valueComponent={renderFarol}
      {...rest}
    />
  );
};

export default GrauRiscoLookup;
